var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconOverview(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(20262 -1914)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(-20262 1914)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-20256.316 1922.421)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4195.824,3471.346c-3.125,0-6.25-.009-9.374.008a1.457,1.457,0,0,1-1.41-.836,11.724,11.724,0,0,1-1.5-6.854,11.908,11.908,0,0,1,8.12-10.7,12.168,12.168,0,0,1,14.53,4.938,12.052,12.052,0,0,1,1.813,8.293,12.585,12.585,0,0,1-1.368,4.246,1.532,1.532,0,0,1-1.516.915C-4189.625,3471.332-4192.725,3471.346-4195.824,3471.346Zm-.012-2.647c.66,0,1.32-.01,1.98,0a.539.539,0,0,0,.6-.4,2.9,2.9,0,0,0-.035-2.152.511.511,0,0,1,.069-.587c.307-.388.594-.791.889-1.188,1.166-1.567,2.338-3.129,3.495-4.7a.984.984,0,0,0-.222-1.469,1.007,1.007,0,0,0-1.424.2c-.125.143-.232.3-.346.453-1.339,1.77-2.683,3.535-4.008,5.316a.745.745,0,0,1-.75.355,2.77,2.77,0,0,0-2.854,3.692.6.6,0,0,0,.662.48C-4197.132,3468.679-4196.484,3468.7-4195.836,3468.7Zm-9.64-2.812a1.4,1.4,0,0,0,1.407,1.439,1.394,1.394,0,0,0,1.412-1.394,1.336,1.336,0,0,0-1.365-1.415A1.349,1.349,0,0,0-4205.476,3465.887Zm17.883-1.369a1.333,1.333,0,0,0-1.4,1.41,1.385,1.385,0,0,0,1.4,1.4,1.4,1.4,0,0,0,1.405-1.436A1.331,1.331,0,0,0-4187.593,3464.518Zm-14.4-4.093a1.349,1.349,0,0,0,1.413-1.366,1.378,1.378,0,0,0-1.424-1.4,1.339,1.339,0,0,0-1.393,1.376A1.31,1.31,0,0,0-4202,3460.425Zm6.157-5.5a1.318,1.318,0,0,0-1.394,1.369,1.365,1.365,0,0,0,1.415,1.407,1.347,1.347,0,0,0,1.39-1.39A1.308,1.308,0,0,0-4195.841,3454.924Z",
    transform: "translate(4208.157 -3452.198)",
    fill: "currentColor",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconOverview);
export default __webpack_public_path__ + "static/media/icon-overview.ff5ca27a.svg";
export { ForwardRef as ReactComponent };